import { FormattedMessage } from 'react-intl';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '../../../../utils/language_support_util';
import GiftingBlockBase from '../GiftingBlockBase';

export default function GenericGiftingBlock() {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <GiftingBlockBase
      imgSrc={`https://cdn-assets.alltrails.com/assets/images/gifting/giftcards-${languageRegionCode}.png`}
      title={<FormattedMessage defaultMessage="Give the gift of adventure" />}
      subtext={
        <FormattedMessage defaultMessage="Whether you’re celebrating someone you love or getting to know someone new, AllTrails Pro makes the perfect gift for the adventurer in your life." />
      }
      ctaText={<FormattedMessage defaultMessage="Gift Pro" />}
      ctaLink={wrapUrlSafe('/gift?ref=homepage_gift_genericgiftingblock', languageRegionCode)}
    />
  );
}
